import { render } from "./producer.html?vue&type=template&id=7d10b1a6&scoped=true&ts=true"
import script from "./producer.ts?vue&type=script&lang=ts"
export * from "./producer.ts?vue&type=script&lang=ts"

import "./producer.scss?vue&type=style&index=0&id=7d10b1a6&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d10b1a6"]])

export default __exports__